import Swiper from "swiper/bundle";
import "./_slider-card.scss";

document.addEventListener("DOMContentLoaded", () => {
  const sliderCards = document.querySelectorAll(".slider-cards");

  sliderCards.forEach((slider) => {
    new Swiper(slider, {
      loop: true,
      spaceBetween: 16,
      slidesPerView: 1.1,
      keyboard: {
        enabled: true,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: true,
      },
      //   autoplay: {
      //     delay: 2500,
      //     disableOnInteraction: false,
      //   },
      breakpoints: {
        768: {
          slidesPerView: 2.1,
        },
        1200: {
          slidesPerView: 3.1,
        },
        // 1400: {
        //   slidesPerView: 4.1,
        //   slidesOffsetBefore: 0, // Impedisce che ci sia spazio prima (a sinistra)
        //   slidesOffsetAfter: 20, // Mantiene spazio extra a destra per mostrare la prossima slide
        // },
      },
    });
  });
});
